import { legacy_createStore as createStore2 } from 'redux'
import { createStore, combineReducers } from 'redux';
import { intlReducer } from 'react-intl-redux';
import { updateIntl } from 'react-intl-redux';
import { createIntl, createIntlCache } from 'react-intl';
import messagesEn from './myapp_src/locale/en.json';
import messagesCn from './myapp_src/locale/cn.json';



const initialStateMyApp = {
  sidebarShow: true,
  sidebarUnfoldable: false,
  theme: 'dark',
  currentUser:{username:'', loginStatus:false,email:null, locale:"en-US", userType: 'guest'},

  localeChangedFlag:0,   //for any component willing to rerender upon language change, listen to this flag

  CoachListData:[],
  coachListFetched:false,

  StudentListData:[],
  studentListFetched:false,

  PostListData:[],
  postListFetched:false,
  IBGAttendanceMonth: '2025-06',   //2025.3.12  makeshift, hold the current month of attendance taking component.

  chatroomButtonNew: false,   //for passing "new button clicked" from GenericItemListHeader.js to PlayerChatroomItemListContent.js which turns a modal window visible.
  attendanceNewPlayerButton: false,  //for passing "new button clicked" ....

  PostListPageSize: 20,
  PostListCurrentPageNum:0,
  PostListTotalCount:0,
  PostListTotalCountFiltered:0,       //given filter, returned "total" - needed for pagination.

  PostListDataFilter:'',
  PostListDataFilter_changed:false,

  PostDataTemp:{postId:'', postContent:''},   //when browser reload on view/edit one post, we need to load the data from server and hold it here for rendering.
  PostDataTempChildren:{parentPostId:'', postChildren:[]},                    //2024.12.29 hold replys to a main post for display.  reload if PostDataTemp.postId !== PostDataTempChildren.parentPostId

  PostListDataCompanion:[],        //2025.3.2 specifically created for holding all Player data when on IBG attendance page: so exporting per player data can merge in detailed per play info if needed.

}

const reducerMyApp = (state = initialStateMyApp, { type, ...rest }) => {

    let newUserInstance={}
    let fromPayload = {}
    let newState = {}

  switch (type) {
    case 'set':
      return { ...state, ...rest }
        //if "rest" contains {sidebarShow|sidebarUnfoldable:true|false}, a new state object with that attribute & value will be returned.

   case 'action_login_success':
        fromPayload = {...rest.payload}
        delete fromPayload.type
        newUserInstance = {...state.currentUser, loginStatus:true, ...fromPayload}
        //newUserInstance = {...state.currentUser, loginStatus:true, email:rest.payload['email'], userType:rest.payload['userType']}
        return { ...state, currentUser:newUserInstance }

    case 'action_logout_reset_state':
      // upon logout:
      //state.currentUser['loginStatus']=false;
      return initialStateMyApp

    case 'action_localstorage_found':
        newUserInstance = {...state.currentUser, loginStatus:true, email:'contacting server...', ...rest.payload}
        console.log('action_localstorage_found, newUserInstance:' + JSON.stringify(newUserInstance))
        //the only benefit of reading from localStorage is that when the user restarts browesr to a deep link of the App, while loginCheck() is reaching the server to confirm existing session, 
        // the app won't jump to "/Login" page first then realize a cached session is still going on. "savedSession" indicates that we're still checking ... as after confirmation, email will be updated as well.
        if( 'locale' in rest.payload){
            myUpdateIntlCache(state.currentUser.locale, rest.payload.locale)
        }
        return { ...state, currentUser:newUserInstance }

    case 'action_login_checked':
        fromPayload = {...rest.payload}
        delete fromPayload.type
        newUserInstance = {...state.currentUser, loginStatus:true, ...fromPayload}
        console.log('action_login_checked, newUserInstance:' + JSON.stringify(newUserInstance))
        if( 'locale' in fromPayload){
            myUpdateIntlCache(state.currentUser.locale, fromPayload.locale)
        }
        return { ...state, localeChangedFlag:state.localeChangedFlag+1, currentUser:newUserInstance }

   case 'action_login_checked_fail':
        newUserInstance = {...state.currentUser, loginStatus:false, email:'Visitor'}
        // 'email' change is used to trigger rerender in case loginChec() is called and failed.
        return { ...state, currentUser:newUserInstance }

    case 'PREFERENCE_SETTING':
        newUserInstance = {...state.currentUser,  locale:rest.settings.locale}
        myUpdateIntlCache(state.currentUser.locale, rest.settings.locale)
        return { ...state, localeChangedFlag:state.localeChangedFlag+1, currentUser:newUserInstance }

    case 'action_coach_list_loaded':
        newState = { ...state, coachListFetched:true, CoachListData:rest.payload.coach_list }
        return newState

    case 'action_student_list_loaded':
        newState = { ...state, studentListFetched:true, StudentListData:rest.payload.student_list }
        return newState

    case 'action_post_list_loaded':
        newState = { ...state, postListFetched:true, PostListData:               rest.payload.post_list,
                                                     PostListDataFilter_changed: false,
                                                     PostListDataCompanion:      rest.payload.player_list,
                                                     PostListTotalCountFiltered: rest.payload.total_count_filtered,
                                                     PostListDataFilter:         rest.payload.filter,
                                                     PostListCurrentPageNum:     rest.payload.currentPageNum,
                                                     }
        return newState


    case 'action_post_one_loaded':
        newState = { ...state, postListFetched:true, PostDataTemp: {postId:rest.payload.postId, postContent:rest.payload.postContent}}
        return newState

    case 'action_post_replies_loaded':
        newState = { ...state, PostDataTempChildren: {parentPostId:rest.payload.parentPostId, postChildren:rest.payload.post_replies}}
        return newState

    case 'action_post_reply_added':
    case 'action_post_reply_deleted':
        const newTempChildrenObj =   {  parentPostId:state.PostDataTempChildren.parentPostId,
                                        postChildren:[] }
        newState = { ...state,
                     PostDataTempChildren: newTempChildrenObj,
                     postListFetched: false,   //also force a postListData reload once navigated to that page.
                     }
        return newState


    case 'action_post_create_edit_saved':
        //force reload of PostListData
        newState = { ...state, postListFetched: false }
        //indicate a reload is needed, but don't wipe out existing data yet.
        return newState

    case 'action_chatroom_new_post_buttonclicked':
       if ( state.chatroomButtonNew === true){
            return {...state}
        }else{
            newState = { ...state, chatroomButtonNew: true }
            //for passing "new button clicked" from GenericItemListHeader.js to PlayerChatroomItemListContent.js which turns a modal window visible.
            return newState
        }

    case 'action_chatroom_new_post_buttonclick_clear':
        if ( state.chatroomButtonNew === false){
            return state
        }else{
            newState = { ...state, chatroomButtonNew: false }
            //for passing "new button clicked" from GenericItemListHeader.js to PlayerChatroomItemListContent.js which turns a modal window visible.
            return newState
        }


    case 'action_attendance_new_player_buttonclicked':
       if ( state.attendanceNewPlayerButtonNew === true){
            return {...state}
        }else{
            newState = { ...state, attendanceNewPlayerButtonNew: true }
            //for passing "new button clicked" from GenericItemListHeader.js to PlayerChatroomItemListContent.js which turns a modal window visible.
            return newState
        }

    case 'action_sort_playerlist_by_name':
        const newlyRankedPostListData = rankPlayerlistByName(state.PostListData)
        newState = {...state, PostListData:newlyRankedPostListData}
        return newState

    case 'action_sort_playerlist_by_id':
        const newlyRankedPostListDataID = rankPlayerlistByID(state.PostListData)
        newState = {...state, PostListData:newlyRankedPostListDataID}
        return newState

    case 'action_ibgplayer_edit_saved':
        newState = { ...state, postListFetched: false }
        return newState

    case 'action_ibg_attendance_month_changed':
        newState = { ...state, postListFetched: false,  IBGAttendanceMonth: rest.payload.month }
        return newState


    default:
      return {...state}
  }
}

function rankPlayerlistByName(PostListData){
    let rankedPostListData = JSON.parse(JSON.stringify(PostListData))
    rankedPostListData = rankedPostListData.sort(
        (a, b) => {
                        const result = a.name.localeCompare(b.name);
                        return result
                    })
    return rankedPostListData
}

function rankPlayerlistByID(PostListData){
    let rankedPostListData = JSON.parse(JSON.stringify(PostListData))
    const rankedPostListData_done = rankedPostListData.sort(
        (a, b) => {
                        const result = parseInt(a.id) -  parseInt(b.id);
                        return result
                    })
    return rankedPostListData_done
}



const initialLocale = initialStateMyApp.currentUser.locale

const messagesLoaded = {
  "en-US": messagesEn,
  "zh-CN": messagesCn,
};

// Combining reducers
const rootReducer = combineReducers({
  intl: intlReducer,
  MyApp: reducerMyApp,
});

// combine initial states

const preloadedState = {
  intl: {
    locale: initialLocale,
    messages: messagesLoaded[initialLocale],
  },
  MyApp: initialStateMyApp,
};


//const store = createStore(reducerCombined, preloadedState);
export const store = createStore(rootReducer, preloadedState);

// to be called from where user changes locale/language: implemented here to access "messagesLoaded"
export const changeLanguageActionForDispatch = (locale) => {
  return updateIntl({
    locale,
    messages: messagesLoaded[locale],
  });
};

//2024.12.6 create an instance for use in utility functions (outside of a component)
const cache = createIntlCache();
const cacheConfig = (theLocale)=>{ return {locale: theLocale,   messages: messagesLoaded[theLocale]}}

let intl = createIntl(cacheConfig(initialLocale), cache);
const intlHolder = {intlCache:intl}

const myUpdateIntlCache = (oldLocale, newLocale)=>{
        if( oldLocale !== newLocale){
            intlHolder.intlCache = createIntl(cacheConfig(newLocale), cache)
        }
    }

export const myTranslate = (messageId, defaultMessage='')=> {
    return intlHolder.intlCache.formatMessage({ id: messageId})
}

export default store